// src/pages/History/19thcentury/IndustrialRevolutionGo.jsx
import React from 'react';
import QuizPage from '../../../components/QuizPageNew2';
import historyImage from '../../../assets/history2/19th_Century_-_Industrial_Revolution.png';

function HistoryPageIndustrialRevolutionGo() {
  return (
    <QuizPage
      title="History: Industrial Revolution"
      subTopic="Industrial Revolution"
      backgroundImage={historyImage}
      returnPath="/History-Industrial-Revolution"
    />
  );
}

export default HistoryPageIndustrialRevolutionGo;
